import React from 'react';
import { DescriptionContainer, Title, Description, DescriptionText, } from '@@Pages/ProductPage/ProductDescription/styled';
export const ProductDescription = ({ title = 'title', description = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, minus?', }) => {
    return (React.createElement(DescriptionContainer, null,
        React.createElement(Title, null, title),
        React.createElement(Description, null,
            React.createElement(DescriptionText, { dangerouslySetInnerHTML: { __html: description } }))));
};
